import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useLoggedInUserRoles } from '~/components/Auth';
import { Roles } from '~/data/user';

export interface UseUserProfileOptionsOutput {
  translatedUserRoles: string;
}

export const useUserProfileOptions = (): UseUserProfileOptionsOutput => {
  const userRoles = useLoggedInUserRoles();
  const { t } = useTranslation();
  const getRoleTranslation = useCallback(
    (role: string) => {
      switch (role) {
        case Roles.HR_ADMIN:
          return t('laHRAdmin');
        case Roles.HR_ADMIN_LIMITED:
          return t('laHRAdminLimited');
        case Roles.HR_SALARY:
          return t('laHRSalary');
        case Roles.HR_STAFF:
          return t('laHR');
        case Roles.HR_DEV:
          return t('laHRDev');
        case Roles.HR_PEOP:
          return t('laHRPeople');
        case Roles.HR_PEOP_DEV:
          return t('laHRPeopleDev');
        case Roles.MANAGER:
          return t('laManager');
        case Roles.ALT_MANAGER:
          return t('laAltManager');
        case Roles.DEPUTY_MANAGER:
          return t('laDeputyManager');
        case Roles.IT_ADMIN:
          return t('laITAdmin');
        case Roles.RECRUITER:
          return t('laRecruiter');
        default:
          return t('laEmployee');
      }
    },
    [t],
  );

  const roleListingOrder = [
    Roles.HR_ADMIN,
    Roles.HR_ADMIN_LIMITED,
    Roles.HR_SALARY,
    Roles.HR_STAFF,
    Roles.HR_DEV,
    Roles.HR_PEOP,
    Roles.HR_PEOP_DEV,
    Roles.MANAGER,
    Roles.ALT_MANAGER,
    Roles.DEPUTY_MANAGER,
    Roles.IT_ADMIN,
    Roles.EMPLOYEE,
    Roles.RECRUITER,
  ];

  const translatedUserRoles = roleListingOrder
    .filter((r) => userRoles.includes(r))
    .map((role) => getRoleTranslation(role))
    .join(' | ');

  return {
    translatedUserRoles,
  };
};
